export var SchedulerResourceType;
(function (SchedulerResourceType) {
    SchedulerResourceType["CHART"] = "chart";
    SchedulerResourceType["DASHBOARD"] = "dashboard";
    SchedulerResourceType["SQL_CHART"] = "sqlChart";
    SchedulerResourceType["APP"] = "app";
})(SchedulerResourceType || (SchedulerResourceType = {}));
// Partial failure types for different scenarios
export var PartialFailureType;
(function (PartialFailureType) {
    PartialFailureType["MISSING_TARGETS"] = "missing_targets";
    PartialFailureType["DASHBOARD_CHART"] = "dashboard_chart";
    PartialFailureType["DASHBOARD_SQL_CHART"] = "dashboard_sql_chart";
})(PartialFailureType || (PartialFailureType = {}));
/**
 * Outcome of evaluating a threshold-alert scheduler against the latest query results.
 * Emitted on `SchedulerDetails.thresholdStatus` and on the `scheduler_job.completed`
 * analytics event so downstream consumers (UI toasts, dashboards) can branch reliably.
 */
export var ThresholdStatus;
(function (ThresholdStatus) {
    ThresholdStatus["MET"] = "met";
    ThresholdStatus["NOT_MET"] = "not_met";
})(ThresholdStatus || (ThresholdStatus = {}));
// Scheduler Runs API types
export var SchedulerRunStatus;
(function (SchedulerRunStatus) {
    SchedulerRunStatus["COMPLETED"] = "completed";
    SchedulerRunStatus["PARTIAL_FAILURE"] = "partial_failure";
    SchedulerRunStatus["FAILED"] = "failed";
    SchedulerRunStatus["RUNNING"] = "running";
    SchedulerRunStatus["SCHEDULED"] = "scheduled";
})(SchedulerRunStatus || (SchedulerRunStatus = {}));
//# sourceMappingURL=schedulerLog.js.map